import { createAction } from '@reduxjs/toolkit';

export const annotation = {
    search: createAction('annotation/search'),
    details: {
        set: createAction('annotation/details/set'),
        reset: createAction('annotation/details/reset'),
    },
};
